import React, { useEffect } from "react";
// import Image from "../../assets/bgimg.png";
import Image from "../../Pyragon/Website Assets/Token Distribution Section/Pyragon-tokenomics.png";
import Image2 from "../../Pyragon/Website Assets/Token Distribution Section/PYRA-TokenDistribution.png";
import AOS from 'aos';
import "aos/dist/aos.css";

import "./values.css";
import Logo from "../../Pyragon/PyragonWebICon.png";

const Values = () => {
    useEffect(()=>{
        AOS.init();
    } , []);

  return (
    <>
      <div id="about-section">
        <img src={Logo} style={{ height: "50px", width: "250px" }} />
        {/* <span>PYRAGON</span> */}
      </div>
      <div className="token sect">
        <div className="token-img ohh-img ">
            <img src={Image} alt="Image"/>
        </div>
        <div className="token-img ohh-img">
          <img src={Image2} alt="Image"/>
          <div className="buttons">
            <button className="btn">LIQUIDITY LOCKED</button>
            <button className="btn">VIEW AUDIT</button>
          </div>
        </div>
      </div>
      </>
  );
};

export default Values;
